import { getBaseUrl } from "@/lib/getBaseURL";

export default async function dataLoader<T>(
  contentType: string,
  language: string,
): Promise<T> {
  const baseUrl = getBaseUrl();
  const url = `${baseUrl}/api/${contentType}?populate=*&locale=${language}`;
  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
    cache: "no-store",
  });

  const contentTypeHeader = response.headers.get("content-type") || "";
  if (!response.ok || !contentTypeHeader.includes("application/json")) {
    const bodyText = await response.text().catch(() => "");
    throw new Error(
      `Unexpected response from Strapi (${response.status} ${response.statusText}). ` +
        `Content-Type: ${contentTypeHeader || "unknown"}. ` +
        `Body: ${bodyText.slice(0, 200)}`,
    );
  }

  const json = await response.json();
  return json.data as T;
}